import * as React from 'react';
import { Provider as PaperProvider, Text, DefaultTheme, } from 'react-native-paper';
import { StyleSheet, View } from 'react-native'
import { whiteColor, blackColor } from '../../common/colors';
import Button from '../../common/Button';
import routes from '../../routing/routes';
import Icon from 'react-native-vector-icons/AntDesign'
import t from '../../translations';

const SendReset = (props) => {

    const theme = {
        ...DefaultTheme,
        roundness: 0,
        colors: {
            ...DefaultTheme.colors,
            primary: blackColor,
        },
    }

    const navigate = () => { props.navigation.navigate(routes.Start) };

        return (<PaperProvider theme={theme}>
           <View style={styles.container}>
            <Text style={styles.x} onPress={navigate}><Icon name='close' size={24} color={blackColor}></Icon></Text>
            <Text style={styles.title}>{t('resetSendMessage_title')}</Text>
                <Text style={styles.headermessage}>
                {t('resetSendMessage_headermessage')}</Text>
                <Text style={styles.headermessagetwo}>
                {t('resetSendMessage_headermessagetwo')}</Text>
                <Text style={styles.headertwomessage}>
                {t('resetSendMessage_headertwomessage')}</Text>
                <Text style={styles.headerlastmessage}>{t('resetSendMessage_headerlastmessage')}</Text>
            </View>
            <View style={styles.messagecontainer}>
               <View style={styles.buttonContainer}>
                <Button onPress={navigate} value={t('resetSendMessage_button_ok')} />
               </View>
            </View>
       </PaperProvider>);
}
export default SendReset;

const styles = StyleSheet.create({
    messagecontainer: {
        backgroundColor: whiteColor,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        display: 'flex',
    },
    x: {
        textAlign: 'right',
    },
    container: {
        padding: 24,
        backgroundColor: whiteColor,
        width: '100%',
        paddingTop: 100,
    },
    title: {
        textAlign: 'center',
        fontSize: 20,
        letterSpacing: 1,
        paddingBottom: 10,
        textTransform: 'uppercase',
        marginRight: 170,
    },
    headermessage: {
        textAlign: 'center',
        fontSize: 12.5,
        padding: 6,
        letterSpacing: 1,
        paddingRight: 50,
        paddingLeft: 0,
        paddingBottom: 2,
    },
    headermessagetwo: {
        textAlign: 'center',
        fontSize: 12.5,
        padding: 0,
        letterSpacing: 1,
        paddingRight: 146,
        paddingLeft: 0,
        paddingBottom: 24,
    },
    headertwomessage: { 
        textAlign: 'center',
        fontSize: 12.5,
        padding: 0,
        letterSpacing: 1,
        paddingRight: 50,
        paddingLeft: 0,
        paddingBottom: 2,
    },
    headerlastmessage: { 
        textAlign: 'center',
        fontSize: 12.5,
        padding: 0,
        letterSpacing: 1,
        paddingRight: 212,
        paddingLeft: 0,
    },
    textButton: {
        color: blackColor,
    },
    divider: {
        height: 10,
        backgroundColor: whiteColor,
    },
    buttonContainer: {
        alignItems: 'center',
        display: 'flex',
        paddingTop: 10,
        paddingLeft: 24,
        paddingRight: 24,
    },
    button: {
        borderWidth: 3,
        width: "100%",
        borderColor: blackColor,

    },
});
    